import { render } from "./WorkspaceError.vue?vue&type=template&id=0e0af3d9&ts=true"
import script from "./WorkspaceError.vue?vue&type=script&lang=ts"
export * from "./WorkspaceError.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__